import v1 from './styles/v1.json';
import v2 from './styles/v2.json';
import v3 from './styles/v3.json';
import v4 from './styles/v4.json';
import v5 from './styles/v5.json';
import v6 from './styles/v6.json';

export { v1, v2, v3, v4, v5, v6 };
export const defaultStyle = v4;
